// SVG-иконки узлов схемы. Пути 1:1 из docs/mockups/demo-flow.html (ICON).
import type { ReactElement } from 'react';

export type IconKind = 'up' | 'img' | 'ai' | 'hand' | 'vid' | 'link' | 'tg' | 'ok';

const PATHS: Record<IconKind, ReactElement> = {
  up: (
    <>
      <path d="M12 15V4M8 8l4-4 4 4" />
      <path d="M4 15v4a1 1 0 001 1h14a1 1 0 001-1v-4" />
    </>
  ),
  img: (
    <>
      <rect x="3" y="4" width="18" height="16" rx="2" />
      <circle cx="8.5" cy="9.5" r="1.5" />
      <path d="M21 16l-5-5L5 20" />
    </>
  ),
  ai: <path d="M12 3l1.6 3.9L17.5 8.5 13.6 10 12 14l-1.6-4L6.5 8.5z" />,
  hand: (
    <>
      <path d="M9 11.5V5.5a1.5 1.5 0 013 0v5" />
      <path d="M12 10V4.5a1.5 1.5 0 013 0V11" />
      <path d="M15 10.5V7a1.5 1.5 0 013 0v6a6 6 0 01-6 6h-1.5a5 5 0 01-4-2l-2.5-3.2a1.5 1.5 0 012.3-1.9L9 14" />
    </>
  ),
  vid: (
    <>
      <rect x="3" y="6" width="13" height="12" rx="2" />
      <path d="M16 10l5-3v10l-5-3z" />
    </>
  ),
  link: (
    <>
      <path d="M9 15l6-6" />
      <path d="M10.5 6.5l1-1a3.5 3.5 0 015 5l-2 2" />
      <path d="M13.5 17.5l-1 1a3.5 3.5 0 01-5-5l2-2" />
    </>
  ),
  tg: <path d="M21 4L3 11l5 2 2 6 3-4 5 4z" />,
  ok: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M8 12l3 3 5-6" />
    </>
  ),
};

export function NodeIcon({ kind }: { kind: IconKind }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {PATHS[kind]}
    </svg>
  );
}

// Иконка микрофона (голос-заглушка).
export function MicIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="9" y="3" width="6" height="11" rx="3" />
      <path d="M5 11a7 7 0 0014 0M12 18v3" />
    </svg>
  );
}

// Иконка отправки.
export function SendIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.1"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12 19V5M5 12l7-7 7 7" />
    </svg>
  );
}
